(function () {
  /**
   * BatchGeo's circle selection Drawing Manager tool. It allows you to click
   * and drag over markers to select them and gives the radius of the circle in
   * the tooltip.
   */
  var BatchGeoDrawingManagerCircle = $.extend(
    true,
    {},
    window.BatchGeoDrawingManagerBaseTool,
    {
      button: {
        class: "drawing-manager-button drawing-manager-button-circle",
        title: "Circle selection tool",
        order: 4,
        icon: "circle",
        mode: "circle",
      },

      // See BaseTool for docs on this method
      buildShape: function () {
        return new google.maps.Circle(
          $.extend(
            {
              map: this.drawingManager.settings.map,
              center: new google.maps.LatLngBounds(
                this.startPosition,
              ).getCenter(),
              radius: 0,
              ...this.drawingManager.settings.shapeOptions,
            },
            this.options,
          ),
        );
      },

      // See BaseTool for docs on this method
      resizeShapeHandler: function (event) {
        var eventLatLng = this.drawingManager.fromEventToLatLng(event);
        // NOTE: The radius *must* be in meters. Don't use current distance scale
        this.shape.setOptions({
          radius: this.drawingManager.distanceBetweenTwoLatLng(
            this.startPosition,
            eventLatLng,
            "m",
          ),
        });

        var scale = this.drawingManager.getDistanceScale();
        var radius = this.drawingManager.distanceBetweenTwoLatLng(
          this.startPosition,
          eventLatLng,
        );

        // NOTE: as mentioned in the reducer for drawing manager this event
        // was only ever needed for Circle as per #1256. Therefore we put
        // the dispatch right in here.
        BatchGeoStore.dispatch({
          type: "DRAWING_MANAGER_SET_SHAPE",
          name: "circle",
          start: {
            lat: this.startPosition.lat(),
            lng: this.startPosition.lng(),
          },
          end: {
            lat: eventLatLng.lat(),
            lng: eventLatLng.lng(),
          },
        });

        this.label.setPosition(eventLatLng, "circle");
        this.label.render(radius.toFixed(2) + scale + " radius");
      },

      /**
       * See BaseTool for docs on this method
       * @override
       */
      drawEndHandler: function () {
        this.drawingManager.disableMapPanning();
        if (this.shape) {
          if (this.shape.map) {
            this.selectionHandler(this.shape);
          }

          this.prevShapes = [
            ...this.prevShapes,
            new google.maps.Circle({
              ...this.drawingManager.settings.shapeOptions,
              map: this.drawingManager.settings.map,
              radius: this.shape.radius,
              center: this.shape.center,
            }),
          ];

          this.shape.setMap(null);
          delete this.shape;
        }

        BatchGeoStore.dispatch({
          type: "DRAWING_MANAGER_SELECTION_STATUS",
          status: false,
        });
      },

      selectionHandler: function (selection) {
        const center = selection.getCenter();
        this.processSelection((item) => {
          var distanceToSelectionCenter =
            google.maps.geometry.spherical.computeDistanceBetween(
              item.getPosition(),
              center,
            );
          return distanceToSelectionCenter <= selection.getRadius();
        });
      },
    },
  );

  window.BatchGeoDrawingManagerCircle = BatchGeoDrawingManagerCircle;
})(window);
